<div *ngIf="data">
  <div class="row" style="border-bottom: 2px solid #ccc; margin-bottom: 1px; margin-top: 2px">
    <div class="col-sm-11 movable">
      <h3 class="head" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" style="margin-bottom: 0px;">
        {{ data.mode | uppercase }} INVENTORY POLICY
      </h3>
    </div>

    <div class="col-sm-1">
      <button type="button" class="btn btn-dark btn-circle btn-xl" [mat-dialog-close]="true" data-dismiss="modal"
        aria-label="Close">
        <span aria-hidden="true">×</span>
      </button>
    </div>
  </div>
  <div class="parentDiv">
    <form [formGroup]="addOrEditform">
      <div class="row">
        <div class="col-md-6 col-width-for-3">
          <div class="drpchildctrl">
            <span class="v1"></span>
            <label required class="searchLable">DOCK </label>

            <p-dropdown id="selSupplier" [options]="data.dockList" [filter]="true" [virtualScroll]="true"
              [itemSize]="30" [showTransitionOptions]="'0ms'" placeholder="Select" optionLabel="dock"
              formControlName="dock" (onChange)="onDockChange()" [resetFilterOnHide]="true"
              [hideTransitionOptions]="'0ms'" autoWidth="true" [style]="{ width: '100%' }" scrollHeight="180px">
            </p-dropdown>
            <ng-container *ngIf="addOrEdit.dock.errors && submitted">
              <small *ngIf="addOrEdit.dock.errors?.required">
                Dock is required.
              </small>
            </ng-container>
          </div>
        </div>
        <div class="col-md-6 col-width-for-3">
          <div class="drpchildctrl">
            <label class="searchLable">KANBAN</label>

             <p-multiSelect id="selSupplier" [options]="kanbanList" [filter]="true" [virtualScroll]="true"
              [itemSize]="30" [showTransitionOptions]="'0ms'" placeholder="Select" optionLabel="kanban"
              formControlName="kanban" [hideTransitionOptions]="'0ms'" autoWidth="true"
              [style]="{ width: '100%' }" scrollHeight="180px" (onChange)="onKanbanChange()" [filterBy]="'kanban'"
              [(ngModel)]="selectedKanban" [resetFilterOnHide]="true"
              optionDisabled="disabled">
            </p-multiSelect>
            

            <!-- <p-multiSelect id="selSupplier" [options]="kanbanList" [filter]="true" [virtualScroll]="true"
            [itemSize]="30" [showTransitionOptions]="'0ms'" placeholder="Select" optionLabel="kanban"
            formControlName="kanban" [resetFilterOnHide]="true" [hideTransitionOptions]="'0ms'" autoWidth="true"
            [style]="{ width: '100%' }" scrollHeight="180px" (onChange)="onKanbanChange()" [filterBy]="'kanban'"
            [(ngModel)]="selectedKanban">
              <ng-template let-item pTemplate="item">
                <div class="p-disabled-option" [class.p-disabled]="checkKanbanAvaibale(item.kanban)">
                      <div>{{item.kanban}}</div>
                  </div>
              </ng-template>
          </p-multiSelect> -->


            <!-- <p-multiSelect 
            [options]="items" 
            optionLabel="name"
            [itemTemplate]="customTemplate">
          </p-multiSelect>
          
          <ng-template let-item pTemplate="customTemplate">
            <div class="p-disabled-option" [class.p-disabled]="item.id > 10">
              <span>{{ item.name }}</span>
            </div>
          </ng-template> -->
          


          </div>
        </div>

        <div class="col-md-6 col-width-for-3">
          <div class="drpchildctrl">
            <label class="searchLable">PART NO</label>
            <p-multiSelect id="selSupplier" [options]="partNoList" [filter]="true" [virtualScroll]="true"
              [itemSize]="30" [showTransitionOptions]="'0ms'" placeholder="Select" optionLabel="item_id"
              formControlName="part_no"  [hideTransitionOptions]="'0ms'" autoWidth="true"
              [style]="{ width: '100%' }" scrollHeight="180px" (onChange)="onPartNoListChange()"
              [resetFilterOnHide]="true"
              [(ngModel)]="selectedPartNo" optionDisabled="disabled">
            </p-multiSelect>
          </div>
        </div>

      </div>
      <div class="row">
        <div class="col-sm-6 col-lg-6" style="margin-top: 10px">
          <div class="drpchildctrl" style="width: 100%">
            <span class="v1"></span>
            <label class="searchLable">POLICY NAME</label>
            <input class="key" type="text" autoWidth="false" maxlength="25" formControlName="policyName"
              placeholder="--Type--" ng-required="true" />

            <ng-container *ngIf="addOrEdit.policyName.errors && submitted">
              <small *ngIf="addOrEdit.policyName.errors?.required">
                Policy Name is required.
              </small>
            </ng-container>
          </div>
        </div>

        <div class="col-sm-6" style="margin-top: 10px">
          <div class="drpchildctrl">
            <label class="searchLable">DESCRIPTION</label>
            <input class="key" type="text" autoWidth="false" maxlength="250" formControlName="description"
              placeholder="--Type--" ng-required="true" />
          </div>
        </div>

        <div class="col-sm-6 col-lg-6" style="margin-top: 10px">
          <div class="drpchildctrl" style="width: 100%">
            <span class="v1"></span>
            <label class="searchLable">EFFECTIVE FROM</label>
            <input class="key" autoWidth="false" formControlName="effectiveFrom" (keydown)="onKeyPressNoDecimal($event)"
              maxlength="6" placeholder="yyyyww" ng-required="true" />
            <ng-container *ngIf="addOrEdit.effectiveFrom.errors && submitted">
              <small *ngIf="addOrEdit.effectiveFrom.errors?.required">
                Effective From is required.
              </small>
            </ng-container>

            <ng-container *ngIf="addOrEditform.hasError('effectiveFromInvalid')">
              <small style="color: red;">
                Effective From is invalid (yyyyww).
              </small>
            </ng-container>

          </div>
        </div>

        <div class="col-sm-6 col-lg-6" style="margin-top: 10px">
          <div class="drpchildctrl" style="width: 100%">
            <label class="searchLable">EFFECTIVE TO</label>
            <input class="key" autoWidth="false" formControlName="effectiveTo" (keydown)="onKeyPressNoDecimal($event)"
              maxlength="6" placeholder="yyyyww" />
            <ng-container *ngIf="addOrEditform.hasError('effectiveToInvalid')">
              <small style="color: red;">
                Effective To is invalid (yyyyww).
              </small>
            </ng-container>
            <ng-container *ngIf="addOrEditform.hasError('efMoreThanEt')">
              <small style="color: red;">
                Effective From cannot be greater than Effective To.
              </small>
            </ng-container>
          </div>
        </div>
        <div class="col-sm-6 col-lg-6" style="margin-top: 10px">
          <div class="row">
            <div class="col-sm-8">
              <div class="row">
                <div class="col-sm-12">
                  <div class="drpchildctrl" style="width: 100%">
                    <span class="v1"></span>
                    <label class="searchLable">MIN DAYS</label>
                    <input class="key" autoWidth="false" formControlName="minDays" type="text"
                      (keydown)="onKeyPress($event)" maxlength="6" placeholder="--Type--"
                      (input)="onInput($event,'minDays')" (focusout)="onFocusOutFunction($event,'minDays')" />
                    <ng-container *ngIf="addOrEdit.minDays.errors && submitted">
                      <small *ngIf="addOrEdit.minDays.errors?.required">
                        Min Days is required.
                      </small>
                      <small *ngIf="addOrEdit.minDays.errors?.pattern">
                        Effective From format is yyyyww.
                      </small>
                    </ng-container>
                    <ng-container *ngIf="addOrEditform.hasError('minDaysMoreThanAllowed')">
                      <small style="color: red;">
                        Min days cannot be greater than 999.99
                      </small>
                    </ng-container>
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="drpchildctrl" style="width: 100%">
                    <span class="v1"></span>
                    <label class="searchLable">MIN BOXES</label>
                    <input class="key" autoWidth="false" formControlName="minBoxes" type="text"
                      (keydown)="onKeyPress($event)" maxlength="6" placeholder="--Type--"
                      (input)="onInput($event,'minBoxes')" (focusout)="onFocusOutFunction($event,'minBoxes')" />
                    <ng-container *ngIf="addOrEdit.minBoxes.errors && submitted">
                      <small *ngIf="addOrEdit.minBoxes.errors?.required">
                        Min Boxes is required.
                      </small>
                    </ng-container>
                    <ng-container *ngIf="addOrEditform.hasError('minBoxesMoreThanAllowed')">
                      <small style="color: red;">
                        Min Boxes cannot be greater than 999.99
                      </small>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-4" style="margin: auto;">
              <img src="/assets/images/choose.gif" alt="seprator image" style="position: absolute;
              height: 60px;
              top: -20px;
              width: 25px;">
              <select class="key" formControlName="minCondition" style="position: absolute;    width: auto;left: 35px;">
                <option value="AN">AND</option>
                <option value="OR">OR</option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-lg-6" style="margin-top: 10px">
          <div class="row">
            <div class="col-sm-8">
              <div class="row">
                <div class="col-sm-12">
                  <div class="drpchildctrl" style="width: 100%">
                    <span class="v1"></span>
                    <label class="searchLable">MAX DAYS</label>
                    <input class="key" autoWidth="false" formControlName="maxDays" type="text"
                      (keydown)="onKeyPress($event)" maxlength="6" placeholder="--Type--"
                      (input)="onInput($event,'maxDays')" (focusout)="onFocusOutFunction($event,'maxDays')" />
                    <ng-container *ngIf="addOrEdit.maxDays.errors && submitted">
                      <small *ngIf="addOrEdit.maxDays.errors?.required">
                        Max Days are required.
                      </small>
                    </ng-container>
                    <ng-container *ngIf="addOrEditform.hasError('minDaysMoreThanMaxDays')">
                      <small style="color: red;">
                        Min days cannot be greater than Max days.
                      </small>
                    </ng-container>
                    <ng-container *ngIf="addOrEditform.hasError('maxDaysMoreThanAllowed')">
                      <small style="color: red;">
                        Max days cannot be greater than 999.99
                      </small>
                    </ng-container>
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="drpchildctrl" style="width: 100%">
                    <span class="v1"></span>
                    <label class="searchLable">MAX BOXES</label>
                    <input class="key" autoWidth="false" formControlName="maxBoxes" type="text"
                      (keydown)="onKeyPress($event)" maxlength="6" placeholder="--Type--"
                      (input)="onInput($event,'maxBoxes')" (focusout)="onFocusOutFunction($event,'maxBoxes')" />
                    <ng-container *ngIf="addOrEdit.maxBoxes.errors && submitted">
                      <small *ngIf="addOrEdit.maxBoxes.errors?.required">
                        Max Boxes are required.
                      </small>
                    </ng-container>
                    <ng-container *ngIf="addOrEditform.hasError('minBoxesMoreThanMaxBoxes')">
                      <small style="color: red;">
                        Min Boxes cannot be greater than Max Boxes.
                      </small>
                    </ng-container>
                    <ng-container *ngIf="addOrEditform.hasError('maxBoxesMoreThanAllowed')">
                      <small style="color: red;">
                        Max Boxes cannot be greater than 999.99
                      </small>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-4" style="margin: auto;">
              <img src="/assets/images/choose.gif" alt="seprator image" style="position: absolute;
              height: 60px;
              top: -20px;
              width: 25px;">
              <select class="key" formControlName="maxCondition" style="position: absolute;width: auto;left: 35px;">
                <option value="AN">AND</option>
                <option value="OR">OR</option>
              </select>
            </div>
          </div>
        </div>
        <!-- <div class="col-sm-6 col-lg-6" style="margin-top: 10px">
          <div class="drpchildctrl" style="width: 100%">
            <span class="v1"></span>
            <label class="searchLable">MIN DAYS</label>
            <input class="key" autoWidth="false" formControlName="minDays" type="text" (keydown)="onKeyPress($event)"
              maxlength="6" placeholder="--Type--" (input)="onInput($event,'minDays')"
              (focusout)="onFocusOutFunction($event,'minDays')" />
            <ng-container *ngIf="addOrEdit.minDays.errors && submitted">
              <small *ngIf="addOrEdit.minDays.errors?.required">
                Min Days is required.
              </small>
              <small *ngIf="addOrEdit.minDays.errors?.pattern">
                Effective From format is yyyyww.
              </small>
            </ng-container>
            <ng-container *ngIf="addOrEditform.hasError('minDaysMoreThanAllowed')">
              <small style="color: red;">
                Min days cannot be greater than 999.99
              </small>
            </ng-container>
          </div>
        </div>

        <div class="col-sm-6 col-lg-6" style="margin-top: 10px">
          <div class="drpchildctrl" style="width: 100%">
            <span class="v1"></span>
            <label class="searchLable">MAX DAYS</label>
            <input class="key" autoWidth="false" formControlName="maxDays" type="text" (keydown)="onKeyPress($event)"
              maxlength="6" placeholder="--Type--" (input)="onInput($event,'maxDays')"
              (focusout)="onFocusOutFunction($event,'maxDays')" />
            <ng-container *ngIf="addOrEdit.maxDays.errors && submitted">
              <small *ngIf="addOrEdit.maxDays.errors?.required">
                Max Days are required.
              </small>
            </ng-container>
            <ng-container *ngIf="addOrEditform.hasError('minDaysMoreThanMaxDays')">
              <small style="color: red;">
                Min days cannot be greater than Max days.
              </small>
            </ng-container>
            <ng-container *ngIf="addOrEditform.hasError('maxDaysMoreThanAllowed')">
              <small style="color: red;">
                Max days cannot be greater than 999.99
              </small>
            </ng-container>

          </div>
        </div>

        <div class="col-sm-6 col-lg-6" style="margin-top: 10px">
          <div class="drpchildctrl" style="width: 100%">
            <span class="v1"></span>
            <label class="searchLable">MIN BOXES</label>
            <input class="key" autoWidth="false" formControlName="minBoxes" type="text" (keydown)="onKeyPress($event)"
              maxlength="6" placeholder="--Type--" (input)="onInput($event,'minBoxes')"
              (focusout)="onFocusOutFunction($event,'minBoxes')" />
            <ng-container *ngIf="addOrEdit.minBoxes.errors && submitted">
              <small *ngIf="addOrEdit.minBoxes.errors?.required">
                Min Boxes is required.
              </small>
            </ng-container>
            <ng-container *ngIf="addOrEditform.hasError('minBoxesMoreThanAllowed')">
              <small style="color: red;">
                Min Boxes cannot be greater than 999.99
              </small>
            </ng-container>
          </div>
        </div>

        <div class="col-sm-6 col-lg-6" style="margin-top: 10px">
          <div class="drpchildctrl" style="width: 100%">
            <span class="v1"></span>
            <label class="searchLable">MAX BOXES</label>
            <input class="key" autoWidth="false" formControlName="maxBoxes" type="text" (keydown)="onKeyPress($event)"
              maxlength="6" placeholder="--Type--" (input)="onInput($event,'maxBoxes')"
              (focusout)="onFocusOutFunction($event,'maxBoxes')" />
            <ng-container *ngIf="addOrEdit.maxBoxes.errors && submitted">
              <small *ngIf="addOrEdit.maxBoxes.errors?.required">
                Max Boxes are required.
              </small>
            </ng-container>
            <ng-container *ngIf="addOrEditform.hasError('minBoxesMoreThanMaxBoxes')">
              <small style="color: red;">
                Min Boxes cannot be greater than Max Boxes.
              </small>
            </ng-container>
            <ng-container *ngIf="addOrEditform.hasError('maxBoxesMoreThanAllowed')">
              <small style="color: red;">
                Max Boxes cannot be greater than 999.99
              </small>
            </ng-container>
          </div>
        </div> -->
      </div>
    </form>

    <ng-container *ngIf="errorMessage">
      <p style="color: red ;">{{ errorMessage }}</p>
    </ng-container>
    <div class="text-right" style="margin-top: 20px">
    </div>

    <div class="spacer"></div>
    <div>
      <button class="review_btn" mat-button (click)="callRespectiveFunction()">
        Save
      </button>

      <button class="cancel_btn" mat-button mat-dialog-close="cancel">
        Cancel
      </button>
    </div>
  </div>
</div>